import React, { HTMLAttributes } from 'react';

import './styles.css';

interface ThreeDotsLoaderProps extends HTMLAttributes<HTMLDivElement> {
  color?: string;
}

const ThreeDotsLoader: React.FC<ThreeDotsLoaderProps> = ({ color = '#fff', ...rest }) => {
  return (
    <div {...rest} className="lds-ellipsis">
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
    </div>
  );
};

export default ThreeDotsLoader;
